"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const ramda_1 = require("ramda");
const getPotentialObj = (potentialObject) => {
    if ((0, lodash_1.isString)(potentialObject))
        return { potentialObject };
    if ((0, lodash_1.isNumber)(potentialObject))
        return { potentialObject };
    if ((0, lodash_1.isArray)(potentialObject))
        return { potentialObject };
    if ((0, lodash_1.isNull)(potentialObject))
        return {};
    if ((0, lodash_1.isUndefined)(potentialObject))
        return {};
    if ((0, lodash_1.isNaN)(potentialObject))
        return {};
    if (typeof potentialObject === "object")
        return potentialObject;
    return {};
};
const mergeAnyDeepLeft = (0, ramda_1.curry)((anyProp1, anyProp2) => (0, ramda_1.mergeDeepLeft)(getPotentialObj(anyProp1), getPotentialObj(anyProp2)));
exports.default = mergeAnyDeepLeft;
//# sourceMappingURL=mergeAnyDeepLeft.js.map